import { Alert, AlertDescription } from "./ui/alert";
import { Button } from "./ui/button";

interface LoginErrorAlertProps {
  description: string;
  onSignUpClick: () => void;
  onPasswordReset: () => void;
}

export const LoginErrorAlert = ({
  description,
  onSignUpClick,
  onPasswordReset,
}: LoginErrorAlertProps) => {
  return (
    <Alert variant="destructive">
      <AlertDescription className="space-y-2">
        <p>{description}</p>
        <div className="flex gap-2">
          <Button type="button" variant="outline" onClick={onSignUpClick}>
            Create Account
          </Button>
          <Button type="button" variant="outline" onClick={onPasswordReset}>
            Reset Password
          </Button>
        </div>
      </AlertDescription>
    </Alert>
  );
};